// GENERATED FILE - DO NOT EDIT BY HAND.
// Source: data/YCP_CARRIER_CONTACTS.csv (the carrier contact record of file).
// Regenerate: node scripts/gen-carrier-contacts.js
//
// Ruling 178 (2026-09-17), master list 4.1. src\data\letterGroup.js resolves its RAILROAD block
// from here. A contact counts as RESOLVED only when it carries a name AND a confirmed_by AND a
// confirmed_on - the MAP-1 rule applied to contacts: a name with nobody's confirmation behind it
// is a claim, not a record. An unresolved row is exported so the gap is visible, and
// letterGroup prints [NOT ON FILE] for it and keeps the group unsendable.
//
// As generated on 2026-10-25: 0 resolved, 17 NOT ON FILE.

// Only these reach letterGroup. An unconfirmed row is deliberately NOT here.
export const CARRIER_CONTACTS = [
];

// The railroads that have no usable contact, named so the absence is reportable rather than mute.
export const CARRIER_CONTACTS_MISSING = [
  { railroad: "Amtrak / NRPC", why: "no contact recorded" },
  { railroad: "CSX Transportation — Former Conrail (Northern Lines)", why: "no contact recorded" },
  { railroad: "Consolidated Rail Corporation (Conrail)", why: "no contact recorded" },
  { railroad: "Delaware & Hudson / Canadian Pacific", why: "no contact recorded" },
  { railroad: "Burlington Northern / BNSF", why: "no contact recorded" },
  { railroad: "CSX Transportation — Former B&O / B&I / CSXI", why: "no contact recorded" },
  { railroad: "CSX Transportation — Former C&O / L&N / Monon / CCR / NT", why: "no contact recorded" },
  { railroad: "CSX Transportation — Former Seaboard Coast Line (SCL)", why: "no contact recorded" },
  { railroad: "Norfolk & Western / Norfolk Southern", why: "no contact recorded" },
  { railroad: "Southern Railway / Norfolk Southern", why: "no contact recorded" },
  { railroad: "Union Pacific / Missouri Pacific / CNW", why: "no contact recorded" },
  { railroad: "Soo Line Railroad (CPKC)", why: "no contact recorded" },
  { railroad: "Duluth Missabe & Iron Range / CN", why: "no contact recorded" },
  { railroad: "Grand Trunk Western / CN", why: "no contact recorded" },
  { railroad: "Long Island Rail Road (LIRR)", why: "no contact recorded" },
  { railroad: "NJ Transit (NJT)", why: "no contact recorded" },
  { railroad: "Metra (Northeast Illinois Regional Commuter Railroad)", why: "no contact recorded" },
  // BEGIN T&E PACK (scripts\gen-te-content.py; task list section 807)
  { railroad: "AWP (A&WP-W RY of AL)", why: "no contact recorded" },
  { railroad: "Alaska Railroad", why: "no contact recorded" },
  { railroad: "Alton & Southern RY", why: "no contact recorded" },
  { railroad: "Amtrak — Amtrak (GO-663)", why: "no contact recorded" },
  { railroad: "Amtrak — Former Conrail–pc–ple (GO-769)", why: "no contact recorded" },
  { railroad: "BNSF Railway — Former Alabama Tennessee & Northern (GO-001)", why: "no contact recorded" },
  { railroad: "BNSF Railway — Former At&sf–coast (GO-017)", why: "no contact recorded" },
  { railroad: "BNSF Railway — Former At&sf–coast (GO-020)", why: "no contact recorded" },
  { railroad: "BNSF Railway — Former At&sf–proper (GO-009)", why: "no contact recorded" },
  { railroad: "BNSF Railway — Former At&sf–western (GO-393)", why: "no contact recorded" },
  { railroad: "BNSF Railway — Former Joint Texas Division of CRI&P and FW&D (GO-JTD)", why: "no contact recorded" },
  { railroad: "Bessemer & LAKE ERIE RR", why: "no contact recorded" },
  { railroad: "CSX Transportation — Allegheny & Eastern Railroad (GO-049)", why: "no contact recorded" },
  { railroad: "CSX Transportation — Florida East Coast Ry (GO-851)", why: "no contact recorded" },
  { railroad: "CSX Transportation — Former C&O–P (GO-201)", why: "no contact recorded" },
  { railroad: "CSX Transportation — Former L&n–proper (GO-513)", why: "no contact recorded" },
  { railroad: "Canadian National (grand Trunk Western RR) — Former DT&I (GO-377)", why: "no contact recorded" },
  { railroad: "Canadian National (illinois Central)", why: "no contact recorded" },
  { railroad: "Canadian National (wisconsin Central)", why: "no contact recorded" },
  { railroad: "Canadian Pacific (SOO LINE)", why: "no contact recorded" },
  { railroad: "Canadian Pacific (delaware & Hudson RY)", why: "no contact recorded" },
  { railroad: "Cedar Rapids & IOWA CITY", why: "no contact recorded" },
  { railroad: "Central Railroad of Indiana", why: "no contact recorded" },
  { railroad: "Chicago RAIL LINK", why: "no contact recorded" },
  { railroad: "Colorado & Wyoming (former GO-306)", why: "no contact recorded" },
  { railroad: "Columbia & Cowlitz RY", why: "no contact recorded" },
  { railroad: "DES Moines Union RY", why: "no contact recorded" },
  { railroad: "Dakota Minnesota & Eastern RR CORP", why: "no contact recorded" },
  { railroad: "Dallas Garland & Northeastern RR", why: "no contact recorded" },
  { railroad: "Delray Connecting RR", why: "no contact recorded" },
  { railroad: "EAST ERIE Commercial RR", why: "no contact recorded" },
  { railroad: "GARY Railway (former Elgin Joliet & Eastern)", why: "no contact recorded" },
  { railroad: "IOWA Interstate RR", why: "no contact recorded" },
  { railroad: "Illinois & Midland", why: "no contact recorded" },
  { railroad: "Indiana Harbor BELT RR — (GO-449)", why: "no contact recorded" },
  { railroad: "Indiana Harbor BELT RR — Formerly GCA 623 (GO-IHB)", why: "no contact recorded" },
  { railroad: "Kansas CITY Southern Lines (KCS) - C,t,y,e,b,f, & O", why: "no contact recorded" },
  { railroad: "Kansas CITY Terminal RY", why: "no contact recorded" },
  { railroad: "LAKE Superior & Ishpeming RR", why: "no contact recorded" },
  { railroad: "LONG Island Railroad", why: "no contact recorded" },
  { railroad: "Longview Portland & Northern", why: "no contact recorded" },
  { railroad: "Louisiana & Delta RR", why: "no contact recorded" },
  { railroad: "Louisiana & North WEST RR", why: "no contact recorded" },
  { railroad: "Metra", why: "no contact recorded" },
  { railroad: "Minnesota Dakota & Western RY", why: "no contact recorded" },
  { railroad: "NEW England Lines", why: "no contact recorded" },
  { railroad: "NEW Jersey Transit RAIL Operations INC", why: "no contact recorded" },
  { railroad: "NEW Orleans Public BELT RR", why: "no contact recorded" },
  { railroad: "Norfolk & Portsmouth BELT LINE", why: "no contact recorded" },
  { railroad: "Norfolk Southern Lines — Alabama Great Southern (GO-898)", why: "no contact recorded" },
  { railroad: "Norfolk Southern Lines — Former N&W–P & Vrgn (GO-680)", why: "no contact recorded" },
  { railroad: "Norfolk Southern Lines — Former N&w–nkp–w&le (GO-687)", why: "no contact recorded" },
  { railroad: "Northern Indiana Commuter", why: "no contact recorded" },
  { railroad: "PORT Terminal RR Association", why: "no contact recorded" },
  { railroad: "Rapid CITY Pierre & Eastern Railroad", why: "no contact recorded" },
  { railroad: "Southeastern Pennsylvania Transportation Authority", why: "no contact recorded" },
  { railroad: "Tacoma Municipal BELT LINE", why: "no contact recorded" },
  { railroad: "Tazewell & Peoria Railroad", why: "no contact recorded" },
  { railroad: "Terminal RR ASSN of ST Louis", why: "no contact recorded" },
  { railroad: "Texas CITY Terminal RY", why: "no contact recorded" },
  { railroad: "Toledo Peoria & Western RR", why: "no contact recorded" },
  { railroad: "Union Pacific — Alameda Belt Line (GO-887)", why: "no contact recorded" },
  { railroad: "Union Pacific — Eastern District (GO-953)", why: "no contact recorded" },
  { railroad: "Union Pacific — Former HB&T (GO-577)", why: "no contact recorded" },
  { railroad: "Union Pacific — Former Missouri Pacific–p (GO-569)", why: "no contact recorded" },
  { railroad: "Union Pacific — Former Texas & Pacific (GO-927)", why: "no contact recorded" },
  { railroad: "White PASS & Yukon RR", why: "no contact recorded" },
  { railroad: "YORK Railway CO", why: "no contact recorded" },
  // END T&E PACK
];

export function contactFor(railroad) {
  return CARRIER_CONTACTS.find(c => c.railroad === railroad) || null;
}

// True when every railroad of record can be addressed. Today it is false, and that is the
// finding master list 4.1 exists to close - not a bug in this file.
export function allCarriersAddressable() {
  return CARRIER_CONTACTS_MISSING.length === 0;
}
